import {
    SectionCard,
    SectionCardH1,
    SectionCardHeading,
    SectionCardSubH1,
} from '../SectionCard';
import { tooltips, views } from '@/copy';
import { DATA_SOURCES } from '@/config/constants';
import DefinitionTooltip from '../DefinitionTooltip';
import TopPhrasesSection from './TopPhrasesSection';
import { downloadItemsAsCSV } from 'utils/formatCSV';
import useInstagramData from 'utils/hooks/useInstagramData';

const hashtagCSVColumns = [
    { key: 'kw', label: 'hashtag' },
    { key: 'volume', label: 'likes' },
];

function TopHashtagsSectionHeading({ name, data, children, ...props }) {
    return (
        <SectionCardHeading {...props}>
            <SectionCardH1>Top Hashtags</SectionCardH1>
            <SectionCardSubH1>
                for <span className="capitalize">{name}</span> by Likes
                <span css="position: relative; top: 2px;">
                    <DefinitionTooltip
                        {...tooltips.avgWeeklyLikes}
                        week={data?.week}
                        year={data?.year}
                        mixpanelMeta={{
                            contentKey: 'hashtagsInstagramSection',
                        }}
                        openOnClick={true}
                    />
                </span>{' '}
                <span className="capitalize">{views.descending}</span>
            </SectionCardSubH1>
            {children}
        </SectionCardHeading>
    );
}

function NoHashtags() {
    return (
        <div
            css={`
                color: ${({ theme }) => theme.neutral_3};
            `}
        >
            No hashtags to show.
        </div>
    );
}

function TopHashtagsSection({
    enabled,
    data,
    controller,
    filename,
    WrapperComponent = SectionCard,
    HeadingComponent = TopHashtagsSectionHeading,
    NoDataComponent = NoHashtags,
    ...props
}) {
    const { brands, categories, countries } = data;
    const dataQuery = useInstagramData({
        page: 1,
        per_page: 1000,
        paginateBy: 'hashtags',
        order_by: 'non_cum_avg_weekly_likes',
        ascending: false,
        hashtags: '*',
        brands,
        categories,
        countries,
        enabled,
    });
    const sortedData =
        dataQuery.data?.map(({ id, hashtag, non_cum_avg_weekly_likes }) => ({
            kw: hashtag,
            fetching: dataQuery.isLoading,
            fetchingData: dataQuery.isLoading,
            id: hashtag,
            volume: non_cum_avg_weekly_likes,
            flagId: id,
        })) || null;

    const handleDownload = () =>
        downloadItemsAsCSV(filename, sortedData, hashtagCSVColumns);

    const isLoading = dataQuery.isLoading;
    const dataReady = sortedData && dataQuery.isSuccess;

    const mixpanelMeta = { contentKey: 'TopHashtags' };

    return (
        <TopPhrasesSection
            data={{ ...data, dataSource: DATA_SOURCES.INSTAGRAM }}
            isLoading={isLoading}
            sortedData={sortedData}
            dataReady={dataReady}
            showTranslations={false}
            handleDownload={handleDownload}
            mixpanelMeta={mixpanelMeta}
            paginateBy="hashtags"
            WrapperComponent={WrapperComponent}
            HeadingComponent={HeadingComponent}
            NoDataComponent={NoDataComponent}
            {...props}
        />
    );
}

export default TopHashtagsSection;
